export const DEFAULT_TAG = 'sanity.preview-kit'
